import api from "./api";

const TrainingService = {
  getAllCourses: async () => {
    try {
      const response = await api.get("/api/training?size=6");
      const data = response.data;
      return Array.isArray(data) ? data : (data?.content || data?.items || data?.data || []);
    } catch (error) {
      console.error("Error fetching training courses:", error);
      throw error;
    }
  },
  
  getCourseById: async (id) => {
    try {
      const response = await api.get(`/api/training/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching training course with id ${id}:`, error);
      throw error;
    }
  },

  getCourseBySlug: async (slug) => {
    try {
      const response = await api.get(`/api/training/${slug}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching training course with slug ${slug}:`, error);
      throw error;
    }
  }
};

export default TrainingService;



